import { combineReducers } from "redux";
import Auth from "./auth/reducers";
import User from "./user/reducers";
import Inventory from "./inventory/reducers";
import loginUser from "./login/reducers";
import aiAssistantReducer from "./slices/aiAssistantSlice";

export default combineReducers({
  Auth,
  User,
  Inventory,
  loginUser,
  aiAssistant: aiAssistantReducer
});
